import React from "react";
import ReactDOM from "react-dom/client";
import { Router } from "./lib/Router";

//Bind ReactDOM to div#root
ReactDOM.createRoot(document.querySelector("#root")).render(
	<React.StrictMode>
		<Router />
	</React.StrictMode>
);